import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import AbstractUserMediaPermissionsOverlay, { abstractMapStateToProps } from './AbstractUserMediaPermissionsOverlay';
import OverlayFrame from './OverlayFrame';
/**
 * Implements a React Component for overlay with guidance how to proceed with
 * gUM prompt.
 */
class UserMediaPermissionsOverlay extends AbstractUserMediaPermissionsOverlay {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _premeetingBackground, logoUrl } = this.props;
        const style = _premeetingBackground ? {
            background: _premeetingBackground,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%'
        } : {};
        return (React.createElement(OverlayFrame, { style: style },
            React.createElement("div", { className: 'content-main-loading' },
                React.createElement("div", { className: 'content-main-loading__baseimage' },
                    React.createElement("img", { className: 'content-main-loading__baseimage__image', alt: 'Please wait for the videocall to connect', src: logoUrl || './images/watermark.svg' })))));
    }
    /**
     * Renders the policy logo.
     *
     * @private
     * @returns {ReactElement|null}
     */
    _renderPolicyLogo() {
        const policyLogoSrc = interfaceConfig.POLICY_LOGO;
        if (policyLogoSrc) {
            return (React.createElement("div", { className: 'policy__logo' },
                React.createElement("img", { alt: this.props.t('welcomepage.logo.policyLogo'), src: policyLogoSrc })));
        }
        return null;
    }
}
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { premeetingBackground } = state['features/dynamic-branding'];
    const { omnicallSettings } = state['features/base/config'];
    return {
        ...abstractMapStateToProps(state),
        _premeetingBackground: premeetingBackground,
        logoUrl: omnicallSettings && omnicallSettings.Omnicall_settings_front_loading_logo
    };
}
export default translate(connect(mapStateToProps)(UserMediaPermissionsOverlay));
